<template>
    <div class="SubstationManagement">
        <div id="left">
            <div id="distributionchart">
                <Videoone></Videoone>
            </div>
            <PowerDistribution v-if="routeName=='PowerDistribution'"></PowerDistribution>
            <PowerProfile v-else-if="routeName=='PowerProfile'"></PowerProfile>
            <PtorageSituation v-else-if="routeName=='PtorageSituation'"></PtorageSituation>
            <div id="areachart" class="row-center" v-else style=" justify-content: space-between;">
                <div class="EchartsLeft">
                    <div class="title">变配电运行概况<span v-if="showtext">（图表低于0时向国网送电）</span></div>
                    <div class="tabCharts">
                        <div class="chartname">实时总功率 (容量：800kVA)</div>
                        <charts id="chartOption1" :option="chartOption1"></charts>
                        <!-- <div id="my_echarts1"  style="height:100%;width:100%"></div> -->
                    </div>
                </div>
                <div class="EchartsRight">
                    <div class="title">微电网运行概况</div>
                    <div class="tab">
                        <span :class="tabSdx == 0? 'tabSpan':''" @click="tabSdx=0">光伏</span>
                        <span :class="tabSdx == 1? 'tabSpan':''" @click="tabSdx=1">储能</span>
                    </div>
                    <div class="tabCharts">
                        <div class="chartname" v-if="tabSdx==0">实时总功率(容量：120kWp)</div>
                        <div class="chartname" v-if="tabSdx==1">剩余电量<span style="color:#666">(预设晚上20~22点放电)</span></div>
                    <!-- <div id="my_echarts" style="height:100%;width:100%"> </div> -->
                        <charts id="chartOption2" :option="chartOption2"></charts>
                    </div>
                </div>
            </div>
        </div>
        <div class="rightYuanqu" v-if="routeName!='PowerDistribution'&&routeName!='PowerProfile'&&routeName!='PtorageSituation'">
            <div class="top">
                <div class="title">
                    <img src="../../assets/img/ch.png" alt="">
                    <div class="titler">
                        <div class="titleName">园区总览
                            <Garden/>
                        </div>
                        <span @click.stop="isShowArea=!isShowArea" >切换<img src="../../assets/img/change0.png" alt=""></span>
                        <div  v-if="isShowArea" ref="area">
                            <Href @closedArea='closedArea' ></Href>
                        </div>
                    </div>
                </div>

                <div class="area row-center">
                    <div class="item">
                        <div class="name">变配电站</div>
                        <div class="num">2</div>
                    </div>
                    <div class="item">
                        <div class="name">光伏电站</div>
                        <div class="num">1</div>
                    </div>
                    <div class="item">
                        <div class="name">储能集装箱</div>
                        <div class="num">1</div>
                    </div>
                    <div class="item">
                        <div class="name">网关在线</div>
                        <div class="num online"><span>2</span>/2</div>
                    </div>
                </div>
            </div>
            <div class="today">
                <div class="today-title">今日事件</div>
                <div style="height:19vh;width:100%;">
                    <charts id="chartOption4" :option="chartOption4"></charts>
                </div>
                <div class="Category row-center">
                    <div class="item">今日事件<span>{{todayCall.num}}</span></div>
                    <div class="item">昨日事件<span>{{todayCall.yesterday}}</span></div>
                    <div class="item">增长率<span>{{Number(todayCall.rate).toFixed(2)}}<span style="font-size:16rem;margin:0">%</span></span></div>
                </div>
                <router-link to='/Unconfirmed-event/Historical' class="more">查看历史记录 》</router-link>
            </div>
            <!-- <TodayEvent/> -->
            <div class="statistics EchartsRight">
                <div class="title">能源统计</div>
                <div class="tab">
                    <span :class="energyIndex == 0? 'tabSpan':''" @click="energyIndex=0">用电</span>
                    <span :class="energyIndex == 1? 'tabSpan':''" @click="energyIndex=1">发电</span>
                    <span :class="energyIndex == 2? 'tabSpan':''" @click="energyIndex=2">储能</span>
                </div>
                <div class="tabCharts">
                    <charts id="chartOption3" :option="chartOption3"></charts>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import Videoone from "./components/videoone";
    const Href = ()=>import('./components/href.vue')
    const TodayEvent = ()=>import('./components/newComponts/todayEvent.vue')
    const Garden =()=> import('./components/garden.vue')
    import * as echarts from 'echarts';
    import charts from "../../components/Energy/charts";
    import PowerDistribution from "../HomePageOverview/PowerDistribution.vue";
    import PowerProfile from "../HomePageOverview/PowerProfile.vue";
    import PtorageSituation from "../HomePageOverview/PtorageSituation.vue";
	import {
		dateFormat,
		dayEnd,
		dayStart,
		nextDay,
		nextMonth,
		nextYear,
		perDay,
		perMonth,
		perYear,
	} from "../../util/DateUtil";
    import { GetAllTransformer, GetloopHistorycurve, diagramDay } from '../../api/common'
    import { mapState } from 'vuex'
    import { getTodayTime, getSevenDays,getLastOrNextFewDateBy } from '../../util/date'
    import {
        AlarmStatistics
    } from '../../api/accident';
    import {
        DailyHistorycurve,dailyPower
    } from '../../api/power';
    export default {
        name: "SubstationManagement", 
        data() {
            return {
                tabSdx:0,
                tabRdx:0,
                tabIdx:0,
                energyIndex:0,
                isShowArea:false,
            
                temp:[],
                transforms:[],
                // 实时总功率
                power:{
                    today:[],
                    yesterday:[]
                },
                // 光伏总功率 
                Pv:{
                    today:[],
                    yesterday:[]
                },
                energy:[],
                // 剩余电量 
                energy1:[],
                weekEnergy:[],
                weekPv:[],
                weekDate:[],
                //今日事件
                todayData:[],
                todayDataInfo:{},
                todayCall:{
                    num:0,
                    yesterday:0,
                    rate:0
                },
                showtext:false
            };
        },
        
        components: {
            Videoone,Href,TodayEvent,Garden,charts,
            PtorageSituation,PowerProfile,PowerDistribution
        },
        computed:{
            ...mapState({weather:state => state.project.weather}),
            //路由名称
            routeName() {
                return this.$route.query.name;
            },
            chartOption1(){
                let list = []
                console.log(this.power,this.Pv)
                if(this.power.today&&this.Pv.today){
                    this.power.today.forEach((item,index)=>{
                        if(this.Pv.today.length>0){
                            let num = (Number(item)+Number(this.Pv.today[index])).toFixed(2)
                            list.push(num)
                            if(num<0){
                                this.showtext = true
                            }
                        }else{
                            list.push(Number(item).toFixed(2))
                            if(Number(item).toFixed(2)<0){
                                this.showtext = true
                            }
                        }
                    })
                }
                
                let list2 = []
                if(this.power.yesterday&&this.Pv.yesterday){
                    this.power.yesterday.forEach((item,index)=>{
                        if(this.Pv.yesterday.length>0){
                            let num = (Number(item)+Number(this.Pv.yesterday[index])).toFixed(2)
                            list2.push(num)
                            if(num<0){
                                this.showtext = true
                            }
                        }else{
                            list2.push(Number(item).toFixed(2))
                            if(Number(item).toFixed(2)<0){
                                this.showtext = true
                            }
                        }
                    })
                }
                return {
                    grid: {
                        left: "0%",
                        right: "3%",
                        bottom: "4%",
                        top: "15%",
                        containLabel: true,
                    },
                    legend: {
                        x:'right',      //可设定图例在左、右、居中
                        itemHeight: 14,
                        itemWidth: 14,
                        itemGap: 30,
                        textStyle:{
                            fontSize: "16rem",//字体大小
                        },
                        data: [
                            {
                            name: '今日',
                            icon: 'rect',
                            },
                            {
                            name: '昨日',
                            icon: 'rect',
                            }
                        ]
                    },
                    tooltip: {
                        trigger: 'axis'
                    },
                    xAxis: {
                        type: 'category',
                        boundaryGap: false,
                        data:this.temp
                    },
                    yAxis: {
                        type: 'value',
                        // name:'实时总功率',
                        nameTextStyle:{
                            align: 'left',
                            padding: [0,0 ,0,24],
                            fontSize:16,  
                            color:"#333",
                        }
                    },
                    series: [
                        {
                            name: '今日',
                            data:  list,
                            type: 'line',
                            smooth: true,
                            itemStyle: {
                                color: '#0D94FF'
                            },
                            areaStyle: {
                                color:{
                                    type: 'linear',
                                    x: 0,
                                    y: 0,
                                    x2: 0,
                                    y2: 1,
                                    colorStops: [{
                                        offset: 0, color: 'rgba(58,132,255, 0.4)' // 0% 处的颜色
                                    }, {
                                        offset: 1, color: 'rgba(58,132,255, 0)' // 100% 处的颜色
                                    }],
                                    global: false // 缺省为 false
                                }
                            }
                        },
                        {
                            data:  list2,
                            type: 'line',
                            name:"昨日",
                            smooth: true,
                            itemStyle: {
                                color: '#5AD8A6'
                            },
                            areaStyle: {
                                color:{
                                    type: 'linear',
                                    x: 0,
                                    y: 0,
                                    x2: 0,
                                    y2: 1,
                                    colorStops: [{
                                        offset: 0, color: 'rgb(90, 216, 166, 0.4)' // 0% 处的颜色
                                    }, {
                                        offset: 1, color: 'rgba(90, 216, 166, 0)' // 100% 处的颜色
                                    }],
                                    global: false // 缺省为 false
                                }
                            }
                        }
                    ]
                }
            },
            chartOption2Data(){
                if(this.tabSdx==1){
                    return [
                        {
                            data:  this.energy1,
                            type: 'line',
                            smooth: true,
                            itemStyle: {
                                color: '#0D94FF'
                            },
                            areaStyle: {
                                color:{
                                    type: 'linear',
                                    x: 0,
                                    y: 0,
                                    x2: 0,
                                    y2: 1,
                                    colorStops: [{
                                        offset: 0, color: 'rgba(58,132,255, 0.4)' // 0% 处的颜色
                                    }, {
                                        offset: 1, color: 'rgba(58,132,255, 0)' // 100% 处的颜色
                                    }],
                                    global: false // 缺省为 false
                                }
                            }
                        }
                    ]
                }else{
                    return [
                        {
                            name: '今日',
                            data:  this.Pv.today,
                            type: 'line',
                            smooth: true,
                            itemStyle: {
                                color: '#0D94FF'
                            },
                            areaStyle: {
                                color:{
                                    type: 'linear',
                                    x: 0,
                                    y: 0,
                                    x2: 0,
                                    y2: 1,
                                    colorStops: [{
                                        offset: 0, color: 'rgba(58,132,255, 0.4)' // 0% 处的颜色
                                    }, {
                                        offset: 1, color: 'rgba(58,132,255, 0)' // 100% 处的颜色
                                    }],
                                    global: false // 缺省为 false
                                }
                            }
                        },
                        {
                            data:  this.Pv.yesterday,
                            type: 'line',
                            name:"昨日",
                            smooth: true,
                            itemStyle: {
                                color: '#5AD8A6'
                            },
                            areaStyle: {
                                color:{
                                    type: 'linear',
                                    x: 0,
                                    y: 0,
                                    x2: 0,
                                    y2: 1,
                                    colorStops: [{
                                        offset: 0, color: 'rgb(90, 216, 166, 0.4)' // 0% 处的颜色
                                    }, {
                                        offset: 1, color: 'rgba(90, 216, 166, 0)' // 100% 处的颜色
                                    }],
                                    global: false // 缺省为 false
                                }
                            }
                        }
                    ]
                }
            },
            chartOption2(){
                return {
                    grid: {
                        left: "0%",
                        right: "3%", 
                        bottom: "4%",
                        top: "15%",
                        containLabel: true,
                    },
                    legend: {
                        x:'right',      //可设定图例在左、右、居中
                        itemHeight: 14,
                        itemWidth: 14,
                        itemGap: 30,
                        textStyle:{
                            fontSize: "16rem",//字体大小
                        },
                        data: [
                            {
                            name: '今日',
                            icon: 'rect',
                            },
                            {
                            name: '昨日',
                            icon: 'rect',
                            }
                        ]
                    },
                    tooltip: {
                        trigger: 'axis'
                    },
                    xAxis: {
                        type: 'category',
                        boundaryGap: false,
                        data:this.temp
                    },
                    yAxis: {
                        type: 'value',
                        // name:'实时总功率',
                        nameTextStyle:{
                            align: 'left',
                            padding: [0,0 ,0,24],
                            fontSize:16,  
                            color:"#333",
                        }
                    },
                    series: this.chartOption2Data
                }
            },
            chartOption3Data(){
                if(this.energyIndex==2){
                   return [{
                        name: '充电量',
                        icon: 'rect',
                        data:this.weekEnergy[0] ,
                        type: 'bar',
                        barWidth:15,
                        itemStyle:{
                            color:'#5B8FF9',
                            barBorderRadius:[7,7,0,0]
                        }
                    },{
                        name: '放电量',
                        data:this.weekEnergy[1] ,
                        type: 'bar',
                        barWidth:15,
                        itemStyle:{
                            color:'#5AD8A6',
                            barBorderRadius:[7,7,0,0]
                        }
                    }]
                }else if(this.energyIndex==1){
                    return [{
                        data:this.weekPv ,
                        type: 'bar',
                        barWidth:15,
                        itemStyle:{
                            color:'#5B8FF9',
                            barBorderRadius:[7,7,0,0]
                        }
                    }]
                }else{
                    return [{
                        data:this.energy ,
                        type: 'bar',
                        barWidth:15,
                        itemStyle:{
                            color:'#5B8FF9',
                            barBorderRadius:[7,7,0,0]
                        }
                    }]
                }
            },
            chartOption3(){
                return {
                    legend: {
                        x:'right',      //可设定图例在左、右、居中
                        itemHeight: 14,
                        itemWidth: 14,
                        itemGap: 30,
                        textStyle:{
                            fontSize: "16rem",//字体大小
                        },
                        data: [
                            {
                            name: '充电量',
                            icon: 'rect',
                            },
                            {
                            name: '放电量',
                            icon: 'rect',
                            }
                        ]
                    },
                    xAxis: {
                        type: 'category',
                        data: this.weekDate
                    },
                    yAxis: {
                        type: 'value',
                        name:'kWh'
                    },
                    series: this.chartOption3Data,
                    grid: {
                        left: "0%",
                        right: "0%",
                        bottom: "4%",
                        top: "20%",
                        containLabel: true,
                    },
                    
                    tooltip: {
                        trigger: 'axis'
                    },
                }
            },
            chartOption4(){
                return {
                   color: [  "#0D94FF","#FF5555","#F5AA00"],
                    tooltip: {
                        trigger: "item",
                    },
                    graphic:{       //图形中间文字
                        type:"text",
                        left:"center",
                        top:"center",
                        style:{
                            text:this.todayDataInfo.sum,
                            textAlign:"center",
                            fontSize:30,
                        }
                    },
                    series: [
                    {
                        // name: "访问来源",
                        type: "pie",
                        radius: ["50%", "70%"],
                        label: {
                            formatter: "{name|{b}}:{time|{c}}",
                            minMargin: 5,
                            edgeDistance: 10,
                            lineHeight: 25,
                            fontSize:"16rem",
                            fontWeight: 800,
                            rich: {
                                time: {
                                    fontSize: "16rem",
                                    // color: "#0D94FF"
                                },
                                name: {
                                    fontSize: "16rem",
                                    // color: "#0D94FF"
                                },
                            },
                        },
                        itemStyle: { // 此配置
                            normal: {
                                borderWidth: 1,
                                borderColor: '#ffffff',
                            },
                            // emphasis: {
                            //     borderWidth: 0,
                            //     shadowBlur: 1,
                            //     shadowOffsetX: 0,
                            //     shadowColor: 'rgba(0, 0, 0, 0.1)'
                            // }
                        },
                        labelLine: {
                            // length: 30,
                            // length2: 100,
                            show: true,
                            lineStyle:{
                                width:2
                            }
                            // color: "#00ffff",
                        },
                        data: this.todayData
                    },
                    ]
                }
            },
            equivalent(){
                let hour = new Date().getHours()
                let month = new Date().getMonth() + 1
                let year = new Date().getFullYear()
                let day = new Date().getDate()

                let obj = {
                        equivalent:0 ,        // 等效
                        todayPowerOut:0,      // 放电量
                        todayPowerIn:160,     // 充电量
                        todayPowerSend:160,     // 放电量
                    }
                
                
                if(this.$store.state.project.weather==1||this.$store.state.project.weather==2){
                    // 等效小时
                    obj.equivalent = (4.5  * ((hour - 6) / 12 ))>4.5?4.5:(4.5  * ((hour - 6) / 12 )).toFixed(2)

                    // 计算发电量
                    let seriesData = [0, 0, 0, 0, 0, 0, 3, 8, 17, 29, 47, 55, 57, 57, 54, 46, 38, 15, 7, 3, 0, 0, 0, 0, 0 ]
                    obj.todayPowerSend = eval(seriesData.splice(0,hour + 1).join("+"))

                }else{
                    obj.equivalent = (8 * ((hour - 6) / 12 )) > 8 ? 8 : (8 * ((hour - 6) / 12 )).toFixed(2)

                    // 计算发电量
                    let seriesData = [0, 0, 0, 0, 0, 0, 7, 10, 31, 60, 90, 110,  117, 114,  109, 91, 61, 31, 11, 9, 0, 0, 0, 0, 0 ]
                    obj.todayPowerSend = eval(seriesData.splice(0,hour + 1).join("+"))
                }

                let timeC = new Date().getTime()
                let timeA = new Date(`${year}-${month}-${day} 20:00:00`).getTime()
                let timeB = new Date(`${year}-${month}-${day} 17:00:00`).getTime()

                // 8点到10点放电电量 
                if(hour >= 20 && hour<= 22){
                    let timeP = (timeC - timeA) / 1000 / 7200 * 160
                    obj.todayPowerOut = timeP.toFixed(2)
                }else{
                    obj.todayPowerOut = 0
                }

                // 0点到4点充电电量
                if(hour >= 0 && hour<= 4){
                    let timeP = (timeC - timeB) / 1000 / 3600 * 400 * 160
                    obj.todayPowerIn = timeP.toFixed(2)
                }else{
                    obj.todayPowerIn = 160
                }

                return obj
            },
        },
        watch: {
            "$store.state.project.projectInfo.projectCoordinate"(n,o){
                this.getWeatherInfo();
            },
            routeName(n,o){
                if(n==undefined){
                    this.tabSdx = 0
                    this.$store.dispatch('HomePage/actionsAllAreas')
                    this.getAlarmStatistics();
                    this.$router.push('SubstationManagement')
                    this.$store.commit("Dthere", 1);
                    this.$store.commit("webId", null);
                    this.temp = []
                    document.addEventListener('click', this.closePopover);
                    for (let i = 0; i <= 24; i++) {
                        this.temp.push(i + "点")
                    }
                    this.getWeatherInfo()
                    setTimeout(() => {
                        this.getTimePower()
                        this.getPVpower()
                    }, 1500);
                    this.getEnergyPower()
                    this.getUseEnergyWeek()
                    this.getWeekpvenergy()
                }
            }
        },
        created(){
            //项目所有 区域
			this.$store.dispatch('HomePage/actionsAllAreas')
            this.getAlarmStatistics();
        },
        mounted() {
            this.$router.push('SubstationManagement')
            this.$store.commit("Dthere", 1);
            document.addEventListener('click', this.closePopover);
            this.temp = []
            for (let i = 0; i <= 24; i++) {
                this.temp.push(i + "点")
            }
            this.getWeatherInfo()
            setTimeout(() => {
                this.getTimePower()
                this.getPVpower()
            }, 1500);
            this.getEnergyPower()
            this.getUseEnergyWeek()
            this.getWeekpvenergy()
        },
        
        beforeDestroy() {
             document.removeEventListener("click", this.closePopover);
        },
        methods: {
            async getAlarmStatistics(){
                // fault: 0  故障报警
                // hiddenDanger: 0  隐患
                // messageNotice: 0 信息通报
                // notice: 7 通知
                // operation: 0  操作命令
                // other: 0  其他
                // overrun: 0 越限异常
                // protections: 0 保护动作
                // sum: 7 总
                // switchDisplacement: 7  开关变位
                // urgent: 0 紧急
                let result = await AlarmStatistics({
                    start: dayStart(new Date()).replace(/\-/g,'/').split("T")[0],
					end: dayEnd(new Date()).replace(/\-/g,'/').split("T")[0],
                    projectId: this.$store.state.project.projectInfo.projectId
                });
                
                let data = result.data.data.eventNum.all
                this.todayDataInfo = data
                this.todayData = [
                    { value: data.notice, name: "通知",label:{color:"#0D94FF"}},
                    { value: data.urgent, name: "紧急" ,label:{color:"#FF5555"}},
                    { value: data.hiddenDanger, name: "隐患" ,label:{color:"#F5AA00"}}
                ]
                //昨日数据
                let day1 = new Date();
                day1.setDate(day1.getDate() - 1);
                let result1 = await AlarmStatistics({
                    start: dayStart(day1).replace(/\-/g,'/').split("T")[0],
					end: dayEnd(day1).replace(/\-/g,'/').split("T")[0],
                    projectId: this.$store.state.project.projectInfo.projectId
                });
                let data1 = result1.data.data.eventNum.all
                this.todayCall.num = data.sum
                this.todayCall.yesterday = data1.sum
                if(this.todayCall.num==0&&this.todayCall.yesterday==0){
                    return
                }
                this.todayCall.rate = (this.todayCall.num-this.todayCall.yesterday)/this.todayCall.yesterday*100
            },
            getWeatherInfo() {
                fetch(
                        "https://devapi.qweather.com/v7/weather/now?location=" +
                        this.$store.state.project.projectInfo.projectCoordinate +
                        "&key=30b91a6005e04fe79c2e64fd7b915df1"
                    )
                    .then((response) => response.json())
                    .then((json) => {
                        switch (json.now.text) {
							case '晴':
								this.$store.commit("Setweather", 0);
								break;
							case '阴':
							case '晴间多云':
							case '多云':
							case '少云':
								this.$store.commit("Setweather", 1);
								break;
							case '雨':
							case '阵雨':
							case '小雨':
							case '中雨':
							case '大雨':
							case '暴雨':
                            case '雪':
							case '小雪':
							case '中雪':
							case '大雪':
							case '暴雪':
								this.$store.commit("Setweather", 1);
                                break;
						}
                    })
                    .catch((e) => {
                        return e;
                    });
            },
            closePopover(e){
                let self = this;
                if (self.$refs.area && !self.$refs.area.contains(e.target)) {
                    if (self.isShowArea == true){
                        self.isShowArea = false
                    }
                }
            },
            closedArea(){
                this.isShowArea = false
            },
            // 获取实时总功率
            async getTimePower(){
                // 先获取项目所有区域
                let that = this
                let areas = this.$store.state.HomePage.areas
                for(let i=0;i<areas.length;i++){
                    let res = await GetAllTransformer({areaId:areas[i].areaId})
                    if(res.data.data.list.length > 0){
                        res.data.data.list.forEach(val => {
                            that.transforms.push(val)
                        })
                    }
                }
                this.getLoopHistorycurve(this.transforms)
            },
            // 获取变压器的历史曲线
            async getLoopHistorycurve(transforms){
                let time = getTodayTime()
                
                let today = []
                let yesterday = []

                for(let i = 0;i<transforms.length;i++){
                    let data = {
                        deviceLoopId:transforms[i].loop_id,
                        start : `${time.today}T00:00:00Z`,
                        "node": 'P_1h',
                        end : `${time.today}T24:00:00Z`,
                    }
                    let res = await GetloopHistorycurve(data)
                    let points  = res.data.data.points
                    points.forEach(item =>{
                        today.push((item.val/1000).toFixed(2))
                    })
                }
                for(let i = 0;i<transforms.length;i++){
                    let data = {
                        deviceLoopId:transforms[i].loop_id,
                        start : `${time.yesterday}T00:00:00Z`,
                        "node": 'P_1h',
                        end : `${time.yesterday}T24:00:00Z`,
                    }
                    let res = await GetloopHistorycurve(data)
                    let points  = res.data.data.points
                    points.forEach(item =>{
                        yesterday.push((item.val/1000).toFixed(2))
                    })
                }
                this.power = {
                    today,
                    yesterday
                }
            },
            // 获取光伏的实时总功率
            async getPVpower(){
                let result = await DailyHistorycurve({
                    start: dayStart(new Date()),
					end: dayEnd(new Date()),
                    projectId: this.$store.state.project.projectInfo.projectId,
                    node:"P"
                });
                let data = result.data.data.points.map(e=>Number(e/1000).toFixed(2))
                this.Pv.today = data
                let day1 = new Date();
                day1.setDate(day1.getDate() - 1);
                let result1 = await DailyHistorycurve({
                    start: dayStart(day1),
					end: dayEnd(day1),
                    projectId: this.$store.state.project.projectInfo.projectId,
                    node:"P"
                });
                let data1 = result1.data.data.points.map(e=>Number(e/1000).toFixed(2))
                this.Pv.yesterday = data1
            },
            // 储能剩余电量 
            getEnergyPower(){
                let arr = [40, 80, 120, 160, 200, 200, 200, 200, 200, 200, 200, 200, 200, 200, 200, 200, 200, 200, 200, 200, 200, 120, 40, 40, 40 ]
                let hour = new Date().getHours() + 1
                this.energy1 = arr.splice(0,hour)
            },
            // 获取能源统计7日用电量
            async getUseEnergyWeek(){
                this.weekDate = getLastOrNextFewDateBy(new Date())
                // 获取项目7天内用电 
                let year = new Date().getFullYear()
                let data = {
                    projectId:this.$store.state.project.projectInfo.projectId,
                    start:`${year+'-'+this.weekDate[0].replace("/","-")}T00:00:00Z`,
                    end:`${year+'-'+this.weekDate[6].replace("/","-")}T24:00:00Z`,
                }
                let res = await diagramDay(data)
                res.data.data.data.forEach((item,index,array)=>{
                    this.energy.push(item.toFixed(2))
                })
            },
            // 获取能源统计7日内发电和储能
            async getWeekpvenergy(){
                
                let xData = getLastOrNextFewDateBy(new Date())
                let year = new Date().getFullYear()
                let result = await dailyPower({
                    start:`${year+'-'+xData[0].replace("/","-")}T00:00:00Z`,
                    end:`${year+'-'+xData[6].replace("/","-")}T24:00:00Z`,
                    projectId: this.$store.state.project.projectInfo.projectId,
                });
                this.weekPv = result.data.data.points.map(e=>Number(e).toFixed(2))

                this.weekEnergy = [[160, 160, 160, 160, 160, 160, 160],[160, 160, 160, 160, 160, 160, 0]]
            }
        },
    };
</script>
<style scoped lang="less">
#distributionchart{
    position: relative;
    z-index: 1;
}
.Category{
    height: 8vh;
    line-height: 8vh;
    text-align: center;
    font-size: 18rem;
    color: #666;
    // margin-top: 30rem;
    border-bottom: 1px solid rgba(0, 0, 0, 0.08);
    justify-content: space-between;
    padding: 0rem 30rem;
    .item{
        // width: 33%;
        span{
            font-size: 24rem;
            font-weight: bold;
            color: #0D94FF;
            margin-left: 13rem;
            vertical-align: -2px;
        }
    }
}
.statistics{
    height: 29.62vh;
    .name{
        text-align: center;
        font-size: 18rem;
    }
}
.EchartsLeft,.EchartsRight{
    .w(528);
    background: #ffffff;
    // height: 100%;
    padding:20rem 23rem;
    position: relative;
    .title{
        font-size: 18rem;
        font-weight: bold;
        margin-bottom: 10rem;
        span{
            color:#666;
            font-weight: 500;
            font-size: 14rem;
        }
    }
}
    .today{
        background: #ffffff;
        .h(400);
        margin-bottom: 8rem;
        position: relative;
        .today-title{
            font-size: 18rem;
            font-weight: bold;
            padding: 23rem 0 0 23rem;
        }
        .more{
            text-align: center;
            color: #999999;
            font-size: 14rem;
            line-height: 5vh;
            cursor: pointer;
            display: block;
            text-decoration:none;
        }
        .more:hover{
            color: #0D94FF;
        }
        .message{
            border-top: 1px solid rgba(0, 0, 0, 0.08);
            background: rgba(0, 43, 102, 0.02);
            .h(200);
            .item{
                height: 48rem;
                font-size: 18rem;
                padding: 0 20rem;
                justify-content: end;
                img{
                    width: 16px;
                }
                span{
                    color: #999999;
                    font-size: 14rem;
                    width: 55px;
                }
                .name{
                    color: #666666;
                    width: 280rem;
                    white-space:nowrap;
                    overflow:hidden;
                    text-overflow:ellipsis;
                    margin-left: 10rem;
                    margin-right: 10rem;
                }
                .statue{
                    width: 150rem;
                    text-align: center;
                }
                .site{
                    color: #999999;

                }
            }
            .item:nth-child(odd){     //偶数行
                background:rgba(0, 43, 102, 0.03);
            }
        }
        
    }
    .area{
        justify-content: space-between;
        padding-top: 10rem;
        .item{
            // width: 25%;
            text-align: center;
            .name{
                font-size: 18rem;
                height: 30px;
            }
            .num{
                color: #0D94FF;
                font-size: 20rem;
                font-weight: bold;
            }
            
            .online{
                color: #333;
                span{
                    color: #68D86A;
                }
            }
        }
    }
    .rightYuanqu{
        .top{
            background-color: #fff;
            padding:0 24rem;
            margin-bottom: 8rem;
            .h(232);
            
        }
        
    }
</style>